// Import Actions
import { SET_PROCESSES, SET_PROCESS } from './ProcessActions';

// Initial State
export const initialState = {
    data: [],
};

// Think to update reducers.js

const ProcessReducer = (state = initialState, action) => {
    switch(action.type) {

        case SET_PROCESSES:
            return {
                ...state,
                data: action.processes,
            };

        case SET_PROCESS:
            return {
                ...state,
                data: action.processes.map(process => (process._id === action.process._id ? action.process : process)),
            };

        default:
            return state;
    }
};

export default ProcessReducer;
